import React, { useEffect, useRef, useState } from "react";
import {
  makeStyles,
  Button,
  Box,
  LinearProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
  Divider,
} from "@material-ui/core";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import _ from "lodash";

import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";

import SelectAllIcon from "@material-ui/icons/SelectAll";

import { fetchUnit, fetchCurrencies } from "src/redux/actions/reference.action";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import { priceNumberFormat } from "src/utils/Number";
import LocationModalComponent from "src/components/modals/LocationModalComponent";
import UnitModalComponent from "src/components/modals/UnitModalComponent";
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  rootLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 400,
    padding: 5,
  },
  selectInputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
}));

PropTypes.ProductForm = {
  valueForm: PropTypes.object,
  headerId: PropTypes.number,
};

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function ItemFormComponent({
  valueForm,
  handleOpenModal,
  handleAddItem,
  handleCancel,
  formState,
  headerId,
  department,
  year,
  status,
}) {
  const classes = useStyles();

  const form = useRef();

  const dispatch = useDispatch();

  const { currencies } = useSelector((state) => state.referenceReducer);

  const {
    result: { currencyid, secureid, countryid },
  } = useSelector((state) => state.loginReducer);

  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openUnitModal, setOpenUnitModal] = useState(false);

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }

    dispatch(fetchCurrencies(currencyid));

    return () => {};
  }, []);

  const findExchangeRate = (id) => {
    let result = _.find(currencies.data, { CURRENCY_ID: id });

    if (result) {
      return result.CURRENCY_EXC_ID;
    }
    return 0;
  };

  const renderCurrencies = () => {
    if (currencies.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return currencies.data.map((i) => (
      <MenuItem key={i.CURRENCY_ID} value={i.CURRENCY_ID}>
        {i.CURRENCY_EXC_CODE} - {i.CURRENCY_EXC_NAME}
      </MenuItem>
    ));
  };

  return (
    <div className={classes.root}>
      <Formik
        key={`ProductForm`}
        ref={form}
        enableReinitialize
        initialValues={{
          ...valueForm,
          PRHIDX: headerId,
          CURR_ID: valueForm.CURR_ID ? valueForm.CURR_ID : currencyid,
          PRDIDX: valueForm.PRDIDX ? valueForm.PRDIDX : "",
          ITEMS_DETAIL: valueForm.ITEMS_DETAIL
            ? `${valueForm.ITEMS_DETAIL}`
            : "",
          SKUIDX: valueForm.SKUIDX ? valueForm.SKUIDX : "",
          PRICE: valueForm.PRICE ? valueForm.PRICE : "",
          QTY: valueForm.QTY ? valueForm.QTY : "",
          PR_UNIT: valueForm.PR_UNIT ? `${valueForm.PR_UNIT}` : "",
          EXC_RATE: valueForm.EXC_RATE ? `${valueForm.EXC_RATE}` : 0,
          AMOUNT: valueForm.AMOUNT ? valueForm.AMOUNT : "",
          DF_AMT_THB: valueForm.DF_AMT_THB ? `${valueForm.DF_AMT_THB}` : 0,
          DF_PRICE_THB: valueForm.DF_PRICE_THB
            ? `${valueForm.DF_PRICE_THB}`
            : 0,
          BGIDX: valueForm.BGIDX ? `${valueForm.BGIDX}` : "",
          BUDGET_CODE: valueForm.BUDGET_CODE ? `${valueForm.BUDGET_CODE}` : "",
          BUDGETP_CODE: valueForm.BUDGETP_CODE
            ? `${valueForm.BUDGETP_CODE}`
            : null,
          REMARK: valueForm.REMARK ? valueForm.REMARK : "",
          PR_BRANDID: valueForm.PR_BRANDID ? valueForm.PR_BRANDID : "",
          PR_DEPARTID: valueForm.PR_DEPARTID ? valueForm.PR_DEPARTID : "",
          SUPCODE: valueForm.SUPCODE ? valueForm.SUPCODE : "",
          D_LOC_NAME: valueForm.D_LOC_NAME ? valueForm.D_LOC_NAME : "",
          D_LOC: valueForm.D_LOC ? valueForm.D_LOC : "",
          D_LOC_CODE: valueForm.D_LOC_CODE ? valueForm.D_LOC_CODE : "",
        }}
        validationSchema={Yup.object().shape({
          ITEMS_DETAIL: Yup.string().required("Item Name is required"),
          BUDGET_CODE: Yup.string().required("Budget Code is required"),
          QTY: Yup.number()
            .moreThan(0, "Value must be strictly greater than 0.")
            .positive("Qty must be a positive number")
            .required("Qty is required"),
          PRICE: Yup.number()
            .moreThan(0, "Value must be strictly greater than 0.")
            .positive("Unit Price must be a positive number")
            .required("Unit Price is required"),
          PR_UNIT: Yup.string().required("Unit Location is required"),
          CURR_ID: Yup.string().required("Currency Location is required"),
          D_LOC_CODE: Yup.string().required("Delivery Location is required"),
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setTimeout(() => {
            values.BGIDX = Number(values.BGIDX);
            values.PRICE = Number(values.PRICE);
            values.PRHIDX = Number(values.PRHIDX);
            values.QTY = Number(values.QTY);
            values.CURR_ID = Number(values.CURR_ID);

            handleAddItem(values);

            setSubmitting(false);
            resetForm({});
          }, 500);
        }}
        render={({
          submitForm,
          isSubmitting,
          setSubmitting,
          touched,
          errors,
          values,
          setFieldValue,
        }) => (
          <Form noValidate>
            <div>
              {isSubmitting && <LinearProgress color="secondary" />}
              <div>
                <Button
                  variant="contained"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenModal();
                  }}
                  color="primary"
                  disabled={status >= 20 ? true : false}
                >
                  <SelectAllIcon /> CHOOSE ITEM
                </Button>
                <Button
                  flex={1}
                  variant="contained"
                  color="primary"
                  style={{
                    alignSelf: "center",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenLocationModal(true);
                  }}
                  disabled={status >= 20 ? true : false}
                >
                  <MyLocationIcon />
                  Choose Delivery Location
                </Button>
              </div>
              <hr />
              <div>
                <Field
                  component={TextField}
                  name="BUDGET_CODE"
                  label="Budget Code"
                  error={Boolean(errors.BUDGET_CODE && errors.BUDGET_CODE)}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Field
                  component={TextField}
                  name="BUDGETP_CODE"
                  label="Project Code"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Field
                  component={TextField}
                  name="ITEMS_DETAIL"
                  label="Item Name"
                  error={Boolean(errors.ITEMS_DETAIL && errors.ITEMS_DETAIL)}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Field
                  component={TextField}
                  name="PRICE"
                  label="Unit Price"
                  error={Boolean(errors.PRICE && touched.PRICE && errors.PRICE)}
                  fullWidth
                  onChange={(e) => {
                    setFieldValue("PRICE", e.target.value);

                    if (values.CURR_ID) {
                      setFieldValue(
                        "EXC_RATE",
                        findExchangeRate(values.CURR_ID)
                      );
                    }

                    if (values.QTY) {
                      setFieldValue(
                        "AMOUNT",
                        values.EXC_RATE * e.target.value * values.QTY
                      );
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                />
              </div>
              <div>
                <FormControl className={classes.selectInputForm}>
                  <InputLabel
                    error={Boolean(
                      errors.CURR_ID && touched.CURR_ID && errors.CURR_ID
                    )}
                    id="CURR_ID"
                  >
                    Please Select Currency
                  </InputLabel>
                  <Field
                    labelId="CURR_ID"
                    component={CustomSelectInput}
                    name="CURR_ID"
                    className={classes.selectInputForm}
                    error={Boolean(
                      errors.CURR_ID && touched.CURR_ID && errors.CURR_ID
                    )}
                    onChange={(e) => {
                      setFieldValue(
                        "EXC_RATE",
                        findExchangeRate(e.target.value)
                      );

                      if (values.QTY) {
                        setFieldValue(
                          "AMOUNT",
                          findExchangeRate(e.target.value) *
                            values.PRICE *
                            values.QTY
                        );
                      }
                    }}
                  >
                    {renderCurrencies()}
                  </Field>
                </FormControl>
                <Field
                  component={TextField}
                  name="QTY"
                  label="QTY"
                  error={Boolean(errors.QTY && touched.QTY && errors.QTY)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("QTY", e.target.value);

                    if (values.CURR_ID) {
                      setFieldValue(
                        "EXC_RATE",
                        findExchangeRate(values.CURR_ID)
                      );
                    }
                    if (values.PRICE) {
                      setFieldValue(
                        "AMOUNT",
                        values.EXC_RATE * values.PRICE * e.target.value
                      );
                    }
                  }}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                />
                <Field
                  label="Unit Type (click)"
                  component={TextField}
                  name="PR_UNIT"
                  id="PR_UNIT"
                  error={Boolean(
                    errors.PR_UNIT && touched.PR_UNIT && errors.PR_UNIT
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenUnitModal(true);
                  }}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                    readOnly: true,
                  }}
                />
                <Field
                  label="Delivery Location (click)"
                  component={TextField}
                  name="D_LOC_CODE"
                  id="D_LOC_CODE"
                  error={Boolean(
                    errors.D_LOC_CODE && touched.D_LOC_CODE && errors.D_LOC_CODE
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenLocationModal(true);
                  }}
                  onChange={() => {}}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                    readOnly: true,
                  }}
                />
              </div>
              <div>
                <Typography variant="h6" gutterBottom>
                  Total Amount : {priceNumberFormat(values.AMOUNT)}
                  {"   "}
                </Typography>
                <Box display="flex" justifyContent="flex-end">
                  <Box>
                    <Button
                      onClick={submitForm}
                      variant="contained"
                      color="primary"
                      disabled={status >= 20 ? true : false}
                    >
                      <AddIcon />
                      {formState}
                    </Button>
                  </Box>
                  <Box marginLeft={2}>
                    <Button
                      disabled={status >= 20 ? true : false}
                      onClick={handleCancel}
                      variant="contained"
                      color="secondary"
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </div>
            </div>
            <LocationModalComponent
              countryid={countryid}
              open={openLocationModal}
              handleClose={() => {
                setOpenLocationModal(false);
              }}
              handleAdd={(value) => {
                const { REF_NAME, REF_RCIDX, REF_CODE } = value;
                setFieldValue("D_LOC_NAME", REF_NAME);
                setFieldValue("D_LOC", REF_RCIDX);
                setFieldValue("D_LOC_CODE", REF_CODE);
              }}
            />
            <UnitModalComponent
              open={openUnitModal}
              handleClose={() => {
                setOpenUnitModal(false);
              }}
              handleAdd={(value) => {
                const { REF_CODE } = value;
                setFieldValue("PR_UNIT", REF_CODE);
              }}
            />
          </Form>
        )}
      />
    </div>
  );
}
